export const UsersTabs = {
  BusinessUsers: {
    IdentitySearch: {
      id: "bu-identity-search",
      name: "Identity Search",
      description:
        "Find B2C sign-in identities for business users by object ID, username (email), or account name."
    },
    UserSearch: {
      id: "bu-user-search",
      name: "Tenant User Search",
      description:
        "Find platform (PLT) user accounts within a tenant by tenant ID, user ID, or username."
    }
  },
  BestHealthUsers: {
    ProfileSearch: {
      id: "cu-profile-search",
      name: "Profile Search",
      description:
        "Find Best Health consumer profiles by name, mobile, or email."
    },
    PatientSearch: {
      id: "cu-identity-search",
      name: "Patient Search",
      description:
        "Find B2C sign-in identities for consumer users by profile ID, object ID, name, email, phone, or user principal name."
    }
  }
};
